import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-start flex-nowrap" }
const _hoisted_2 = {
  type: "submit",
  class: "c-button ml-20 u-valign-inline-button flex-no-shrink overflow-hidden w-130 md:w-150"
}
const _hoisted_3 = {
  key: "pending",
  class: "flex justify-center items-center"
}
const _hoisted_4 = { key: "addToWishList" }
const _hoisted_5 = { class: "button-text__label transition-transform duration-300 ease-in-out" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.validation,
    onSubmit: _ctx.submit
  }, {
    default: _withCtx(({ resetForm }) => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_InputText, {
          name: "name",
          label: _ctx.labels.nameYourList,
          "input-clear": false,
          class: "flex-1"
        }, null, 8, ["label"]),
        _createElementVNode("button", _hoisted_2, [
          _createVNode(_Transition, {
            mode: "out-in",
            "enter-active-class": _ctx.enterAnimation,
            "leave-active-class": _ctx.leaveAnimation
          }, {
            default: _withCtx(() => [
              (_ctx.pending)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_c_icon, {
                      name: "icon-checkmark-medium",
                      class: "h-15 mr-5"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.labels.createdList), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.labels.createList), 1)
                  ]))
            ]),
            _: 1
          }, 8, ["enter-active-class", "leave-active-class"])
        ])
      ])), [
        [_directive_click_outside, resetForm]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema", "onSubmit"]))
}